import { cva } from 'class-variance-authority';

/**
 * Class strings only — never a CSS file, never a raw colour.
 *
 * Every colour here is a design token from `src/styles/globals.css`. The token
 * set carries no default Tailwind palette, so a value that does not resolve is
 * a visible bug rather than a silent grey.
 */
export const buttonStyles = cva(
  [
    // `cursor-pointer` is explicit even though `<button>` defaults to it:
    // a CSS reset (or a parent rule with higher specificity) can strip the
    // default, and the user-visible bug is "the button doesn't feel pressable".
    'inline-flex shrink-0 cursor-pointer select-none items-center justify-center gap-2',
    'rounded-control border font-medium',
    'transition-colors',
    'disabled:cursor-not-allowed disabled:opacity-60',
  ],
  {
    variants: {
      variant: {
        primary: 'border-accent bg-accent text-accent-content hover:opacity-90',
        secondary:
          'border-border bg-surface-raised text-content hover:border-border-strong hover:bg-surface-sunken',
        ghost: 'border-transparent bg-transparent text-content-muted hover:bg-surface-sunken hover:text-content',
        danger: 'border-critical bg-critical text-accent-content hover:opacity-90',
      },
      size: {
        /** Inline-row action: "View", "Edit", "Review Plan". */
        xs: 'h-7 px-2.5 text-xs',
        sm: 'h-8 px-3 text-xs',
        md: 'h-9 px-4 text-sm',
        lg: 'h-11 px-5 text-base',
      },
    },
    defaultVariants: {
      variant: 'primary',
      size: 'md',
    },
  },
);

/** Spinner shown while `loading`. Decorative: `aria-busy` carries the state. */
export const buttonSpinnerStyles = 'size-4 shrink-0 animate-spin';